var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Button } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { ComposerMode } from '../types/index';
import { resolveBlockingAlerts } from '../utils/composerIssues';
import { useConfig } from '../context/ConfigContext';
/**
 * Pre-submit alert for blockers outside the form. Always visible while
 * blocked; Save stays enabled and scrolls here (useFooterValidation).
 *
 * One alert exists today (personal calendar required), so its presentation
 * is inlined. Future improvement (second alert): render from a
 * Record<BlockingAlertId, presentation> keyed off the resolver's issue id —
 * see the note on resolveBlockingAlerts in utils/composerIssues.ts.
 */
export var ComposerBlockingAlert = function () {
    var t = useTranslation('meetingRooms').t;
    var _a = useCalendarIntegrationsContext(), canCreateRequestWithPersonalCalendar = _a.canCreateRequestWithPersonalCalendar, isLoadingCalendarIntegration = _a.isLoadingCalendarIntegration;
    var _b = useEventComposerGlobalContext(), requestOnlySpace = _b.requestOnlySpace, composerMode = _b.composerMode;
    var environmentUrls = useConfig().environmentUrls;
    var dashboardUrl = environmentUrls.dashboardUrl;
    // Shared resolver keeps this display and the footer's submit gate agreeing
    // on "is it blocked?".
    var _c = __read(resolveBlockingAlerts({
        isCreateMode: composerMode === ComposerMode.CREATE,
        isSpaceRequestOnlyEvent: !!requestOnlySpace,
        canCreateRequestWithPersonalCalendar: canCreateRequestWithPersonalCalendar,
        isLoadingCalendarIntegration: isLoadingCalendarIntegration,
    }), 1), alert = _c[0];
    if (!alert)
        return null;
    return (_jsx("div", { style: { padding: '20px 20px' }, "data-composer-section": "blocking-alert", children: _jsx(AlertContainer, { showIcon: false, type: "error", title: t('errors.personal_calendar_required_for_request_only_space'), action: _jsx(Button, { size: "small", onClick: function () {
                    return window.open("".concat(dashboardUrl, "/account/integrations"), '_blank');
                }, children: t('go_to_integrations') }) }) }));
};
var AlertContainer = styled(Alert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  gap: 8px;\n\n  .ant-alert-actions {\n    align-self: flex-start;\n  }\n"], ["\n  flex-direction: column;\n  gap: 8px;\n\n  .ant-alert-actions {\n    align-self: flex-start;\n  }\n"])));
var templateObject_1;
